import { IVacationLog } from '../../features/offduty-logs/vacationLogSlice'
import React from 'react';

export const VacationLogContext = React.createContext<IVacationLog | undefined>(undefined)
